<template>
  <v-footer class="black ma-0 pa-0">
    <v-container class="col-10 ma-0-auto pa-0">
      <v-row class="d-flex justify-space-between footer-row">
        <!-- ABOUT INTRO -->
        <v-col
          class="col-12 col-md-7 col-lg-4 ma-0 pa-0 d-flex flex-column justify-space-between footer-full-height"
        >
          <div>
            <v-divider class="divider green" width="100%"></v-divider>

            <h3 class="footer-title">{{ this.$t('Footer').title0 }}</h3>

            <p class="footer-text footer-item footer-item-paragraph mt-2">
              {{ this.$t('Footer').title1 }}
            </p>
          </div>
          <div class="footer-opacity d-none d-lg-block">
            <div style="margin-left: -15px;">
              <v-img
                src="@/assets/images/homepage/logo_unl_pt_pb_negativo_0.png"
                width="150px"
              ></v-img>
            </div>
            <h5 class="footer-item">
              © {{ new Date().getFullYear() }} Universidade Nova de Lisboa — All
              Rights Reserved
            </h5>
          </div>
        </v-col>

        <!-- FEATURED -->
        <v-col
          class="col-12 col-md-4 col-lg-2 ma-0 pa-0 footer-full-height mt-8 mt-md-0"
        >
          <v-divider class="divider green" width="100%"></v-divider>

          <h3 class="footer-title">{{ this.$t('Footer').title3 }}</h3>

          <v-list class="transparent">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="footer-item">
                  <a class="footer-item" href="/about">
                    {{ this.$t('Footer').title41 }}
                  </a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="footer-item">
                  <a class="footer-item" href="/academics">
                    {{ this.$t('Footer').title42 }}
                  </a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="footer-item">
                  <a class="footer-item" href="/industry">
                    {{ this.$t('Footer').title43 }}
                  </a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="footer-item">
                  <a class="footer-item" href="/technologies">
                    {{ this.$t('Footer').title44 }}
                  </a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>

        <!-- CONTACTS -->
        <v-col
          class="col-12 col-md-7 col-lg-2 ma-0 pa-0 footer-full-height mt-8 mt-lg-0"
        >
          <v-divider class="accent divider green" width="100%"></v-divider>

          <h3 class="footer-title">{{ this.$t('Footer').title2 }}</h3>

          <v-list two-line class="transparent">
            <v-list-item class="mb-2">
              <v-list-item-icon>
                <v-icon class="mr-2">mdi-email</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="footer-item">{{
                  this.$t('Contacts').email
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item class="mb-2">
              <v-list-item-icon>
                <v-icon class="mr-2">mdi-phone</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="footer-item">{{
                  this.$t('Contacts').phone
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon class="mr-2">mdi-map-marker</v-icon>
              </v-list-item-icon>

              <v-list-item-content class="ml-2">
                <v-list-item-title class="footer-item footer-subitem">
                  {{ this.$t('Contacts').address.line0 }}
                </v-list-item-title>
                <v-list-item-subtitle wrap class="footer-item footer-subitem">{{
                  this.$t('Contacts').address.line1
                }}</v-list-item-subtitle>
                <v-list-item-subtitle class="footer-item footer-subitem">{{
                  this.$t('Contacts').address.line2
                }}</v-list-item-subtitle>
                <v-list-item-subtitle class="footer-item footer-subitem"
                  >{{ this.$t('Contacts').address.postalCode }}
                  {{ this.$t('Contacts').address.city }} —
                  {{
                    this.$t('Contacts').address.country
                  }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>

        <!-- SOCIAL MEDIA -->
        <v-col
          class="col-12 col-md-4 col-lg-2 ma-0 pa-0 d-flex flex-column justify-space-between footer-full-height mt-8 mt-lg-0"
        >
          <div>
            <v-divider class="accent divider green" width="100%"></v-divider>
            <h3 class="footer-title">{{ this.$t('Footer').title4 }}</h3>

            <v-btn
              v-for="social in socialMedia"
              :key="social.id"
              icon
              :href="social.url"
              target="_blank"
            >
              <v-icon>{{ social.icon }}</v-icon>
            </v-btn>
          </div>
          <div class="footer-opacity pt-8 pt-md-0">
            <a
              class="footer-item"
              href="http://inovamedialab.org"
              target="_blank"
            >
              {{ this.$t('Footer').madeBy }}
            </a>
          </div>
          <div class="footer-opacity pt-8 pt-md-0 d-lg-none">
            <div style="margin-left: -15px;">
              <v-img
                src="@/assets/images/homepage/logo_unl_pt_pb_negativo_0.png"
                width="150px"
              ></v-img>
            </div>
            <h5 class="footer-item">
              © {{ new Date().getFullYear() }} Universidade Nova de Lisboa — All
              Rights Reserved
            </h5>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
      socialMedia: [
        {
          id: 1,
          icon: 'mdi-facebook',
          url: this.$t('Contacts').socials.facebook,
        },
        {
          id: 2,
          icon: 'mdi-twitter',
          url: this.$t('Contacts').socials.twitter,
        },
        {
          id: 3,
          icon: 'mdi-linkedin',
          url: this.$t('Contacts').socials.linkedin,
        },
        {
          id: 4,
          icon: 'mdi-instagram',
          url: this.$t('Contacts').socials.instagram,
        },
      ],
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
  },
}
</script>

<style lang="scss">
.footer-row {
  padding: 60px 0;
  min-height: 280px;
  .v-list-item__icon {
    margin: 0px !important;
  }
  i {
    font-size: 24px !important;
    color: #e4e3e1 !important;
  }
  .v-list-item {
    min-height: 24px;
    padding: 0px !important;
  }
  .v-list-item__content {
    padding: 0px !important;
    overflow: visible !important;
  }
}

.footer-title {
  font-family: $body-font-family;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #1bb493 !important;
  padding-bottom: 1rem;
}

.footer-text {
  text-align: left;
  overflow-wrap: normal;
}

.footer-item-paragraph {
  height: auto !important;
}

.footer-item {
  line-height: large;
  font-family: $body-font-family !important;
  font-weight: normal !important;
  font-size: 14px !important;
  overflow: visible !important;
  text-decoration: none !important;
  color: #e4e3e1 !important;
  a {
    text-decoration: none !important;
    color: #e4e3e1 !important;
    &:hover {
      color: #1bb493 !important;
    }
  }
}

.footer-subitem {
  height: 17px;
  color: #e4e3e1 !important;
}

.footer-opacity {
  opacity: 0.5;
  h5 {
    height: 22px;
  }
}

.footer-full-height {
  max-height: 200px;
}
</style>
